import * as React from 'react'
import TextInput from '../../../TextInput/TextInput'
import { FORM_CONSTRAINTS } from '../../constants'
import { IEventRegistration } from './EventRegistration.types'

const EventRegistration: React.FC<IEventRegistration> = ({ event, register, errors, control, formState, getFieldState }) => {
  return (
    <>
      <TextInput
        name="firstName"
        text="First Name"
        type="name"
        register={register}
        errors={errors}
        maxLength={FORM_CONSTRAINTS.firstName.maxLength}
      />
      <TextInput
        name="lastName"
        text="Last Name"
        type="name"
        register={register}
        errors={errors}
        maxLength={FORM_CONSTRAINTS.lastName.maxLength}
      />
      <TextInput
        name="email"
        text="Email"
        type="email"
        maxLength={FORM_CONSTRAINTS.email.maxLength}
        register={register}
        errors={errors}
      />
      <TextInput
        name="phone"
        text="Phone"
        type="phone"
        register={register}
        errors={errors}
        control={control}
        getFieldState={getFieldState}
        formState={formState}
      />

      <input type={'hidden'} id={'event'} defaultValue={event} {...register('event')} />
    </>
  )
}

export default EventRegistration
